import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  '@keyframes radarSweep': {
    '0%': { transform: 'translate(-50%, -50%) rotate(0deg)' },
    '100%': { transform: 'translate(-50%, -50%) rotate(360deg)' },
  },
  '@keyframes ringPulse': {
    '0%, 100%': { transform: 'translate(-50%, -50%) scale(1)', opacity: 0.15 },
    '50%': { transform: 'translate(-50%, -50%) scale(1.08)', opacity: 0.35 },
  },
  '@keyframes glowPulse': {
    '0%, 100%': { opacity: 0.3 },
    '50%': { opacity: 0.7 },
  },
  '@keyframes fadeIn': {
    '0%': { opacity: 0 },
    '100%': { opacity: 1 },
  },
  '@keyframes dotPulse': {
    '0%, 80%, 100%': { opacity: 0.3, transform: 'scale(0.8)' },
    '40%': { opacity: 1, transform: 'scale(1)' },
  },
  PopupLoader: {
    '&__overlay': {
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100vh',
      zIndex: 2000,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      background:
        'linear-gradient(135deg, rgba(2,6,23,0.92) 0%, rgba(11,17,32,0.95) 50%, rgba(15,23,42,0.92) 100%)',
      backdropFilter: 'blur(8px)',
      WebkitBackdropFilter: 'blur(8px)',
      animation: '$fadeIn 0.3s ease-out',
    },

    '&__spinner': {
      position: 'relative',
      width: 160,
      height: 160,
    },

    '&__ring': {
      position: 'absolute',
      borderRadius: '50%',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      animation: '$ringPulse 3s ease-in-out infinite',

      '&--1': {
        width: 80,
        height: 80,
        border: '1px solid rgba(14, 165, 233, 0.25)',
        animationDelay: '0s',
      },
      '&--2': {
        width: 120,
        height: 120,
        border: '1px solid rgba(14, 165, 233, 0.15)',
        animationDelay: '0.5s',
      },
      '&--3': {
        width: 160,
        height: 160,
        border: '1px solid rgba(14, 165, 233, 0.08)',
        animationDelay: '1s',
      },
    },

    '&__radar': {
      position: 'absolute',
      width: 160,
      height: 160,
      borderRadius: '50%',
      top: '50%',
      left: '50%',
      background:
        'conic-gradient(from 0deg, transparent 0deg, rgba(14,165,233,0.25) 30deg, transparent 60deg)',
      animation: '$radarSweep 4s linear infinite',
      WebkitMaskImage:
        'radial-gradient(circle, black 30%, transparent 70%)',
      maskImage: 'radial-gradient(circle, black 30%, transparent 70%)',
    },

    '&__center-dot': {
      position: 'absolute',
      width: 8,
      height: 8,
      borderRadius: '50%',
      background: '#0EA5E9',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      boxShadow:
        '0 0 12px rgba(14,165,233,0.6), 0 0 24px rgba(14,165,233,0.3)',
    },

    '&__glow': {
      position: 'absolute',
      width: 200,
      height: 200,
      borderRadius: '50%',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      background:
        'radial-gradient(circle, rgba(14,165,233,0.12) 0%, transparent 70%)',
      animation: '$glowPulse 4s ease-in-out infinite',
      pointerEvents: 'none',
    },

    '&__label': {
      marginTop: 32,
      display: 'flex',
      alignItems: 'center',
      fontSize: 13,
      fontWeight: 400,
      color: '#94A3B8',
      letterSpacing: '0.15em',
      textTransform: 'uppercase',
      fontFamily:
        "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    },

    '&__dots': {
      display: 'inline-flex',
      gap: 4,
      marginLeft: 8,
      '& span': {
        width: 4,
        height: 4,
        borderRadius: '50%',
        backgroundColor: '#94A3B8',
        animation: '$dotPulse 1.4s infinite ease-in-out',
        '&:nth-child(1)': { animationDelay: '0s' },
        '&:nth-child(2)': { animationDelay: '0.2s' },
        '&:nth-child(3)': { animationDelay: '0.4s' },
      },
    },
  },
});

export { useStyles };
